import { EditableSelect, EditableText, EditableNumber } from "ui-components/EditableInput2";
import dayjs from "dayjs";

export const formatDateTime = (value) => (value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "");

const userAndCreatedOnColumns = [
  {
    header: "User ID",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    cell: ({ getValue }) => formatDateTime(getValue()),
    exportFormat: formatDateTime,
  },
];


export const cycleCountListcolumns = [
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "Count Qty",
      accessorKey: "countQty",
      ...({ cell: EditableNumber }),
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ getValue }) => {
        const dateValue = getValue();
        if (!dateValue) {
          return ""; // Return empty string if the expiry date is null or empty
        }
        const formattedDate = new Date(dateValue).toLocaleDateString("en-GB"); // Format the date to "DD/MM/YYYY" or based on the user's locale
        return formattedDate;
      },
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ getValue }) => {
        const statusValue = getValue();
        if (statusValue === "P") {
          return "Complete Scanning";
        } else if (statusValue === "O") {
          return "In Scanning";
        }
        else if (statusValue === "C") {
          return "Data Uploaded";
        }
        return statusValue; // Return the original value if it's not "P" or "O"
      },
    },
    // {
    //   header: "Retail Barcode",
    //   accessorKey: "retailBarcode",
    // },  
    ...userAndCreatedOnColumns,
  ];

  export const cycleCountListLookup = [
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "System Qty",
      accessorKey: "sysQty",
    },
    {
      header: "Count Qty",
      accessorKey: "countQty",
    },
    {
      header: "Variance",
      accessorKey: "variance",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ getValue }) => {
        const dateValue = getValue();
        if (!dateValue) {
          return ""; // Return empty string if the expiry date is null or empty
        }
        const formattedDate = new Date(dateValue).toLocaleDateString("en-GB"); // Format the date to "DD/MM/YYYY" or based on the user's locale
        return formattedDate;
      },
    },
    ...userAndCreatedOnColumns,
  ];

  export const latestCountListcolumns = [
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    {
      header: "Vendor Code",
      accessorKey: "vendorCode",
      //...{ cell: (props) => EditableSelect({ ...props,options:vendorOptions}) },
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "Sys Qty",
      accessorKey: "sysQty",
    },
    {
      header: "Count Qty",
      accessorKey: "phyQty",
      ...({ cell: EditableNumber }),
    },
    {
      header: "Variance",
      accessorKey: "variance",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ row }) => {
        const dateValue = row.original.expiryDate;
        return dateValue
          ? new Date(dateValue).toLocaleDateString("en-GB") // Format to dd/MM/yyyy
          : "";
      },
    },
    // {
    //   header: "Retail Barcode",
    //   accessorKey: "retailBarcode",
    // },
  ];

  export const VarianceReportColumns = [
    // {
    //   header: "CCountNo",
    //   accessorKey: "cCountNo",
    // },
    // {
    //   header: "Zone ID",
    //   accessorKey: "zoneID",
    // },
    // {
    //   header: "Location ID",
    //   accessorKey: "locationID",
    // },
    // {
    //   header: "Carton Id",
    //   accessorKey: "cartonID",
    // },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "Total Short Qty",
      accessorKey: "totalShortQty",
    },
    {
      header: "Total Extra Qty",
      accessorKey: "totalExtraQty",
    },
    {
      header: "Variance",
      accessorKey: "variance",
    },
    // {
    //   header: "MLN",
    //   accessorKey: "mln",
    // },
    // {
    //   header: "Expiry Date",
    //   accessorKey: "expiryDate",
    //   cell: ({ row }) => {
    //     const dateValue = row.original.expiryDate;
    //     return dateValue
    //       ? new Date(dateValue).toLocaleDateString("en-GB") // Format to dd/MM/yyyy
    //       : "";
    //   },
    // },
  ];

  export const CycleCountVarianceComparisonColumns = [
    {
      header: "CCountNo",
      accessorKey: "cycleCountNo",
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    },
    {
      header: "Variance Type",
      accessorKey: "varianceType",
      cell: ({ getValue }) => {
        const value = getValue();
        if (value === "MIA") return "MIA";
        if (value === "EXTRA") return "Extra";
        return value;
      },
    },
    {
      header: "From Location",
      accessorKey: "fromLocation",
    },
    {
      header: "To Location",
      accessorKey: "toLocation",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ row }) => {
        const dateValue = row.original.expiryDate;
        return dateValue
          ? new Date(dateValue).toLocaleDateString("en-GB")
          : "";
      },
    },
    {
      header: "Base UOM",
      accessorKey: "baseUOM",
    },
    {
      header: "Open Qty",
      accessorKey: "quantity",
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ getValue }) => {
        const statusValue = getValue();
        if (statusValue === "O") {
          return "Open";
        } else if (statusValue === "C") {
          return "Closed";
        }
        return statusValue;
      },
    },
  ];

  export const VarianceReportDetailsColumns = [
    {
      header: "CCountNo",
      accessorKey: "cCountNo",
    },
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "Sys Qty",
      accessorKey: "sysQty",
    },
    {
      header: "Phy Qty",
      accessorKey: "phyQty",
    },
    {
      header: "Short Qty",
      accessorKey: "shortItemQty",
    },
    {
      header: "Extra Qty",
      accessorKey: "extraItemQty",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ row }) => {
        const dateValue = row.original.expiryDate;
        return dateValue
          ? new Date(dateValue).toLocaleDateString("en-GB") // Format to dd/MM/yyyy
          : "";
      },
    },
  ];